import { useState } from 'react';
import Container from "react-bootstrap/esm/Container"
import Row from "react-bootstrap/esm/Row"
import Col from "react-bootstrap/esm/Col"
import { Link} from "react-router-dom"
import "../styles/index.css"

export default function Header({logo}){
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return(
        <>
         <div className="warning-banner">
    <Container>
        <p>
            <span className="warning-icon">🔞</span>
            Southernhillsplay is a free social casino platform. We do not collect payments, bets, or financial information, and we do not offer gambling or the opportunity to win real money.
        </p>
    </Container>
</div>

            <header>
                <Container>
                    <Row className="align-items-center">
                        <Col xs={8} md={8}>
                        <Link to="/" className="header-logo-text">
                        Southernhillsplay
</Link>
                        </Col>
                        
                        {/* Desktop Menu */}
                        <Col xs={4} md={4} className="d-none d-md-block">
                            <div className="links">
                                <Link className="linkBtn" to="/play">Play Now</Link>
                            </div>
                        </Col>

                        {/* Mobile Burger Menu */}
                        <Col xs={4} className="d-md-none text-right">
                            <button 
                                className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
                                onClick={toggleMenu}
                                aria-label="Toggle menu"
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </Col>
                    </Row>
                </Container>

                {/* Mobile Menu Overlay */}
                <div className={`mobile-menu ${isMenuOpen ? 'show' : ''}`}>
                    <div className="mobile-menu-content">
                        <Link 
                            className="mobile-link" 
                            to="/play" 
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Play Now
                        </Link>
                    </div>
                </div>
            </header>
        </>
    )
}
